<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn color="primary" x-small text @click="goBack">
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Meus Horários
          <e-help-tooltip :text="$constants.tooltips.horariosInstrutores.meusHorarios" />
        </h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card outlined>
          <v-card-text>
            <horario-tabs v-model="tab" class="mb-4" />

            <div v-if="tab === 0">
              <horario-dia-filtro v-model="dataSelecionada" class="mb-3" @buscar="buscarDia" />

              <horario-lista-agrupada :registros="registrosDia" />
            </div>

            <div v-if="tab === 1">
              <horario-lista-agrupada :registros="registrosUltimos10Dias" />
            </div>

            <div v-if="tab === 2">
              <horario-periodo-filtro
                v-model="periodo"
                class="mb-3"
                @buscar="buscarPeriodo"
                @gerar-pdf="gerarPdfPeriodo"
              />
              <horario-lista-agrupada :registros="registrosPeriodo" />
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <e-modal-espelho-ponto-pdf
      :dialog="dialogPdf"
      :pdf="pdf"
      title="Espelho de Ponto"
      @close="fecharPdf"
    />
  </main-template>
</template>

<script>
const hoje = () => new Date().toISOString().slice(0, 10);

export default {
  name: "MeusHorariosPage",
  data() {
    return {
      tab: 0,
      dataSelecionada: hoje(),
      periodo: [],
      registrosDia: [],
      registrosUltimos10Dias: {},
      registrosPeriodo: {},
      dialogPdf: false,
      pdf: null,
    };
  },
  watch: {
    tab(value) {
      if (value === 1 && Object.keys(this.registrosUltimos10Dias).length === 0) {
        this.buscarUltimos10Dias();
      }
    },
  },
  mounted() {
    this.buscarDia();
    this.buscarUltimos10Dias();
  },
  beforeDestroy() {
    this.limparPdfAtual();
  },
  methods: {
    goBack() {
      this.$goBack();
    },
    async buscarDia() {
      try {
        this.$loaderService.open("Carregando horários");
        this.registrosDia = await this.$services.instrutorHorariosService.meusHorariosDia({
          data: this.dataSelecionada,
        });
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async buscarUltimos10Dias() {
      try {
        this.registrosUltimos10Dias =
          await this.$services.instrutorHorariosService.meusHorariosUltimos10Dias();
      } catch (error) {
        this.$handleError(error);
      }
    },
    async buscarPeriodo(form) {
      try {
        this.$loaderService.open("Carregando período");
        this.registrosPeriodo = await this.$services.instrutorHorariosService.meusHorariosPeriodo(
          form
        );
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async gerarPdfPeriodo(form) {
      try {
        this.$loaderService.open("Gerando espelho de ponto");
        this.limparPdfAtual();
        this.pdf = await this.$services.instrutorHorariosService.meusHorariosPeriodoPdf(form);
        this.dialogPdf = true;
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    fecharPdf() {
      this.dialogPdf = false;
      this.limparPdfAtual();
    },
    limparPdfAtual() {
      if (this.pdf) {
        window.URL.revokeObjectURL(this.pdf);
        this.pdf = null;
      }
    },
  },
};
</script>
